// eslint-disable-next-line jsdoc/require-jsdoc
export function convertExtendedSourceToFile(source) {
    return {
        sourceUUID: source.uuid,
        relativePath: source.relativePath,
        name: source.name,
        lastModified: source.lastModified,
        size: source.size,
        baseURL: source.baseURL,
        arrayBuffer: () => source.arrayBuffer(),
        text: () => source.text(),
        stream: () => source.stream(),
    };
}
//# sourceMappingURL=convertExtendedSourceToFile.js.map